var _defs, _text, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWithGrabaloTech = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LOGO_GRA\\u0301BALO_BLANCO_nuevo_claim_7-3-21_Imagen",
    "data-name": "LOGO GRA\\u0301BALO BLANCO nuevo claim 7-3-21\\xA0Imagen",
    viewBox: "0 0 776.37 140.76",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".tech_grabalo_1{font-size:55.01px;fill:#4c4c4c;font-family:Roboto-Regular, Roboto;letter-spacing:-0.06em;}.tech_grabalo_2{letter-spacing:-0.01em;}.tech_grabalo_3{fill:#10212e;}.tech_grabalo_4{fill:#00a3da;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "tech_grabalo_1",
    transform: "translate(0 93.96)"
  }, "T", /*#__PURE__*/React.createElement("tspan", {
    className: "tech_grabalo_2",
    x: 29.78,
    y: 0
  }, "ecnolog\xEDa de"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M616.29,153l-10.45,4,10.45,4v2.44l-13.19-5.21v-2.54l13.19-5.2Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M627.16,142.56h2.56L620,170.3h-2.56Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M645.36,157.22H632.7c.35,2.74,2.56,4.57,5.65,4.57a5.82,5.82,0,0,0,4.51-1.89l1.57,1.83a7.85,7.85,0,0,1-6.16,2.53c-5,0-8.39-3.33-8.39-8a7.62,7.62,0,0,1,7.82-7.95c4.51,0,7.72,3.24,7.72,8C645.42,156.6,645.39,157,645.36,157.22Zm-12.66-2h10a5,5,0,0,0-10,0Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M664.15,155.1v9h-2.83v-8.65c0-3.07-1.53-4.57-4.21-4.57-3,0-4.93,1.8-4.93,5.18v8h-2.83v-15.6h2.71v2.35a6.67,6.67,0,0,1,5.62-2.5C661.46,148.33,664.15,150.51,664.15,155.1Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M677.31,142.23h2.83v21.85h-2.83Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M697.89,154.66v9.42H695.2V162c-.94,1.41-2.68,2.24-5.12,2.24-3.53,0-5.77-1.88-5.77-4.59,0-2.5,1.62-4.57,6.28-4.57h4.49v-.56c0-2.38-1.39-3.76-4.18-3.76a7.85,7.85,0,0,0-4.94,1.67l-1.18-2.12a10.44,10.44,0,0,1,6.45-2C695.48,148.33,697.89,150.39,697.89,154.66Zm-2.82,4.65v-2.18h-4.36c-2.79,0-3.59,1.09-3.59,2.42,0,1.57,1.3,2.53,3.45,2.53a4.46,4.46,0,0,0,4.49-2.77Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M737,155.1v9h-2.83v-8.65c0-3.07-1.47-4.57-4-4.57-2.83,0-4.68,1.8-4.68,5.18v8h-2.83v-8.65c0-3.07-1.47-4.57-4-4.57-2.82,0-4.68,1.8-4.68,5.18v8h-2.82v-15.6h2.7v2.32a6.33,6.33,0,0,1,5.39-2.47,5.82,5.82,0,0,1,5.42,2.89,7,7,0,0,1,6-2.89C734.37,148.33,737,150.51,737,155.1Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M756.31,157.22H743.66c.35,2.74,2.56,4.57,5.66,4.57a5.8,5.8,0,0,0,4.5-1.89l1.57,1.83a7.82,7.82,0,0,1-6.15,2.53c-5,0-8.39-3.33-8.39-8a7.61,7.61,0,0,1,7.81-7.95c4.5,0,7.71,3.24,7.71,8C756.37,156.6,756.34,157,756.31,157.22Zm-12.66-2h10a5,5,0,0,0-10,0Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M786.2,155.1v9h-2.83v-8.65c0-3.07-1.47-4.57-4-4.57-2.83,0-4.69,1.8-4.69,5.18v8h-2.82v-8.65c0-3.07-1.48-4.57-4-4.57-2.83,0-4.68,1.8-4.68,5.18v8h-2.83v-15.6H763v2.32a6.32,6.32,0,0,1,5.38-2.47,5.81,5.81,0,0,1,5.42,2.89,7,7,0,0,1,6-2.89C783.61,148.33,786.2,150.51,786.2,155.1Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M790.06,156.28a8.11,8.11,0,1,1,8.12,8A7.76,7.76,0,0,1,790.06,156.28Zm13.37,0a5.27,5.27,0,1,0-5.25,5.51A5.13,5.13,0,0,0,803.43,156.28Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M818.6,148.33v2.74c-.22,0-.43,0-.65,0-3,0-4.92,1.86-4.92,5.27v7.77h-2.82v-15.6h2.71v2.62C813.91,149.27,815.85,148.33,818.6,148.33Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M821.57,143.65a1.86,1.86,0,0,1,1.86-1.86h.05a1.83,1.83,0,0,1,1.91,1.8,1.91,1.91,0,0,1-3.82.06Zm.5,4.83h2.82v15.6h-2.82Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M842.65,154.66v9.42H840V162c-.94,1.41-2.68,2.24-5.12,2.24-3.54,0-5.77-1.88-5.77-4.59,0-2.5,1.61-4.57,6.28-4.57h4.47v-.56c0-2.38-1.38-3.76-4.18-3.76a7.82,7.82,0,0,0-4.93,1.67l-1.18-2.12a10.42,10.42,0,0,1,6.45-2C840.24,148.33,842.65,150.39,842.65,154.66Zm-2.83,4.65v-2.18h-4.36c-2.79,0-3.59,1.09-3.59,2.42,0,1.57,1.3,2.53,3.45,2.53a4.47,4.47,0,0,0,4.5-2.77Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M860.38,156.38v2.53l-13.2,5.21v-2.44l10.49-4-10.49-4v-2.43Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gr\\xE1balo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M597.57,91.65c-.09-.11-15.27,0-15.33,0s.06,2.91.06,2.91c-9-5.19-21.18-3.66-27.35,4.76-6.35,8.67-6.92,18.21-2.45,27.85,5.52,11.89,19.07,15.18,28.92,8.89a17.08,17.08,0,0,1-.09,8.88,7.1,7.1,0,0,1-2.89,4.42A8.94,8.94,0,0,1,566.77,148c-.38-.4-.76-.8-.61-.55-3,.53-13.24,2.47-14.93,2.82a18.75,18.75,0,0,0,4.64,7.59c7,7.15,18.88,9.37,28.41,5.17,8.38-3.69,13.1-10.16,13.21-19.41C597.69,129,597.55,106.25,597.57,91.65ZM577,123.35a7.37,7.37,0,0,1-8.3-1.49c-4.72-4.36-3.13-12.93,2.77-15a8,8,0,0,1,10.37,6.77c.06.5.09,1,.13,1.49A8.64,8.64,0,0,1,577,123.35Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M728.18,98.17a19.7,19.7,0,0,0-22.29-5.47c-1.31.52-2.55,1.24-4.09,2V72.19H686.58V138H702v-2.26l1.15.64A19.63,19.63,0,0,0,727.49,133C736.15,124,736.48,107.53,728.18,98.17Zm-20.83,25.28c-3.42-1.33-5-4.14-5.27-7.68a8.36,8.36,0,0,1,3.87-8.08,7.27,7.27,0,0,1,8.31,0,8,8,0,0,1,3.88,6.73c0,7-5.4,11.13-10.8,9Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M665.38,91.57l-.07,3.08-1.43-.79a19.65,19.65,0,0,0-24,3.55c-8.41,8.7-9.12,24.54-1.43,34,5.46,6.7,12.5,9.13,20.91,7a43.69,43.69,0,0,0,6-2.47l0,2h15.43l0-46.41Zm-.9,27.53a7.79,7.79,0,0,1-8.28,4.8c-4-.48-6.93-4.26-6.91-9.65a8,8,0,0,1,4.86-7.09,7.28,7.28,0,0,1,8.32,1.35,9.31,9.31,0,0,1,2,10.58Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M769.78,91.86l-.1,2.82-1.17-.63c-9.3-5.33-20.76-2.82-26.58,6.2-6,9.3-6.18,19.11-.78,28.72a19.56,19.56,0,0,0,23.74,9.09,51,51,0,0,0,4.79-2.18v2.18h15.46l.12-46.21Zm-9.29,32c-3.11-.38-5.61-2.78-6.6-6.31a9.15,9.15,0,0,1,3.27-9.73c4.79-3.39,11.57-.25,12.31,5.7.08.64.11,1.29.14,1.62C769.3,120.89,765.4,124.5,760.49,123.89Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M858.92,108.43c-3-10.37-12.41-17.14-23.78-17.24-1.78.21-3.59.29-5.33.65a23.73,23.73,0,0,0-15.88,35.67c5.58,9.18,14.24,12.5,24.66,11.4A23.75,23.75,0,0,0,858.92,108.43ZM835.18,124a8.76,8.76,0,1,1,8.57-8.84,8.55,8.55,0,0,1-8.57,8.84Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M790.89,72.15H806V138H790.88Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M631.19,91.43v15.42c-1-.33-2-.7-2.89-.91a7.84,7.84,0,0,0-9.77,7.56c-.11,7.53,0,15.06,0,22.58V138H603.17V91.79c.12-.14,15.3-.14,15.33,0-.08.53,0,3.34,0,3.82,2-1.15,3.92-2.39,6-3.33A12.71,12.71,0,0,1,631.19,91.43Z",
    transform: "translate(-84.01 -47.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_3",
    d: "M661.05,88.1H649.1V76.15a12,12,0,1,1,12,11.95Z",
    transform: "translate(-84.01 -47.11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo_simbolo",
    "data-name": "Logo simbolo"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "tech_grabalo_4",
    cx: 414.34,
    cy: 114.64,
    r: 26.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "tech_grabalo_4",
    d: "M524.46,89.17v42.07H482.4a42.07,42.07,0,1,1,42.06-42.07Z",
    transform: "translate(-84.01 -47.11)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWithGrabaloTech, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/with_grabalo_tech.cf3fa951.svg";
export { ForwardRef as ReactComponent };